import { ReactComponent as BatteryIcon } from 'assets/UPS/batteryNormal.svg';
import { ReactComponent as BatteryIconWarning } from 'assets/UPS/batteryWarning.svg';
import { ReactComponent as BatteryIconDanger } from 'assets/UPS/batteryDanger.svg';
import { ReactComponent as BlocksIcon } from 'assets/UPS/blocksNormal.svg';
import { ReactComponent as BlocksIconWarning } from 'assets/UPS/blocksWarning.svg';
import { ReactComponent as BlocksIconDanger } from 'assets/UPS/blocksDanger.svg';
import { ReactComponent as HealthIcon } from 'assets/UPS/healthNormal.svg';
import { ReactComponent as HealthIconWarning } from 'assets/UPS/healthWarning.svg';
import { ReactComponent as HealthIconDanger } from 'assets/UPS/healthDanger.svg';
import classNames from 'utilities/ClassNames';

const UpsCard = ({ item, onClick }: { item: { id: number, title: string, desc: string, tag: { name: string, value: string, percentage: string }, type: 'normal' | 'warning' | 'danger' | 'dark' }, onClick: React.Dispatch<React.SetStateAction<number | null>>; }) => {

  const bgColor: { normal: string, dark: string, warning: string, danger: string } = {
    normal: 'bg-black hover:bg-dark border-[#134366] border',
    dark: 'bg-dark hover:bg-dark border-[#134366] border',
    warning: 'bg-[#FDBD4D]/30 border-[#FDBD4D] border',
    danger: 'bg-red/30 border-red border'
  };

  return (
    <div
      onClick={() => onClick(item.id)}
      className={classNames(bgColor[item.type], "p-1 h-full rounded-md max-w-52 cursor-pointer")}
    >
      <div className="flex flex-wrap justify-between h-full max-h-full">
        <div className="w-full">
          <h4 className='text-lg xl-2xl:text-2xl font-bold text-center'>{item.title}</h4>
          <p className='text-sm xl-2xl:text-[14px] text-center'>{item.desc}</p>
        </div>
        <div className="w-full h-max grid grid-cols-3 gap-1 font-bold text-sm xl-2xl:text-md">
          <div className={classNames(bgColor[item.type], 'p-1 xl-2xl:py-4 flex flex-col items-center rounded')}>
            {(item.type === 'normal' || item.type === 'dark') && <BatteryIcon />}
            {item.type === 'warning' && <BatteryIconWarning />}
            {item.type === 'danger' && <BatteryIconDanger />}
            <p className='mt-1'>3</p>
            <p>Strings</p>
          </div>
          <div className={classNames(bgColor[item.type], 'p-1 xl-2xl:py-4 flex flex-col items-center rounded')}>
            {(item.type === 'normal' || item.type === 'dark') && <BlocksIcon />}
            {item.type === 'warning' && <BlocksIconWarning />}
            {item.type === 'danger' && <BlocksIconDanger />}
            <p className='mt-1'>24</p>
            <p>Blocks</p>
          </div>
          <div className={classNames(bgColor[item.type], 'p-1 xl-2xl:py-4 flex flex-col items-center rounded')}>
            {(item.type === 'normal' || item.type === 'dark') && <HealthIcon />}
            {item.type === 'warning' && <HealthIconWarning />}
            {item.type === 'danger' && <HealthIconDanger />}
            <p className='mt-1'>95%</p>
            <p>Health</p>
          </div>
        </div>
        <div className="w-full">
          <p className='text-sm xl-2xl:text-lg text-center'>{item.tag.name}</p>
          <div className='w-full grid grid-cols-2 gap-1 font-bold text-md xl-2xl:text-xl'>
            <div className={classNames(bgColor[item.type], 'border border-[#134366] p-2 text-center rounded')}>{item.tag.value}</div>
            <div className={classNames(bgColor[item.type], 'border border-[#134366] p-2 text-center rounded')}>{item.tag.percentage}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpsCard;